import { render } from "./Snow.vue?vue&type=template&id=1b9c3747"
const script = {}

import "./Snow.vue?vue&type=style&index=0&id=1b9c3747&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__